import { mapActions, mapState } from 'vuex';

export const SHOW_ODDS_KEY = 'odds-key';

export default {
  computed: {
    ...mapState('app', ['showOdds']),
    buttonText() {
      return this.showOdds ? 'Show Last Trade Price' : 'Show Implied Odds of Winning';
    },
  },
  methods: {
    ...mapActions('app', ['setShowOdds']),
    onShowOdds() {
      this.setShowOdds(true);
    },
    onDontShowOdds() {
      this.setShowOdds(false);
    },
    onToggle() {
      if (this.showOdds) {
        this.setShowOdds(false);
      } else {
        this.setShowOdds(true);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/price-odds-toggle-popup/price-odds-toggle-popup.js